export enum TransferTypeEnum {
    intake = 0,
    stockRelocation = 1,
    stockTransfer = 2,
    dispatch = 3, // No longer used as a Transfer Type. Dispatches are separate from Transfer Requests now.
    writeOff = 4,
    regrafting = 5,
}